"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutRow = exports.CheckoutRowWrapper = void 0;
require("core-js/modules/es6.promise");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.assign");
const regenerator_1 = __importDefault(require("@babel/runtime/regenerator"));
require("regenerator-runtime/runtime");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try {
    var info = gen[key](arg);
    var value = info.value;
}
catch (error) {
    reject(error);
    return;
} if (info.done) {
    resolve(value);
}
else {
    Promise.resolve(value).then(_next, _throw);
} }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _utils_1 = require("@utils");
const _theme_1 = require("@theme");
const _store_1 = __importDefault(require("@store"));
const _api_1 = __importDefault(require("@api"));
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const stripe_js_1 = require("@stripe/stripe-js");
var stripePromise = stripe_js_1.loadStripe(process.env.GATSBY_STRIPE_PUBLIC_KEY); // Component
var PaymentForm = function PaymentForm(_ref) {
    var tier = _ref.tier, setTier = _ref.setTier;
    var stripe = react_stripe_js_1.useStripe();
    var stripeElements = react_stripe_js_1.useElements(); // UI
    var _useGlobal = _store_1.default(function (state) {
        return state.notification;
    }, function (actions) {
        return actions.setNotification;
    }), setNotification = _useGlobal[1];
    var _React$useState = react_1.default.useState(false), processing = _React$useState[0], setProcessing = _React$useState[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal2[1]; // state
    var _React$useState2 = react_1.default.useState(true), recurring = _React$useState2[0], setRecurring = _React$useState2[1];
    var toggleRecurring = function toggleRecurring() {
        return setRecurring(!recurring);
    };
    var _useGlobal3 = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.setUser;
    }), user = _useGlobal3[0], setUser = _useGlobal3[1];
    var _React$useState3 = react_1.default.useState((user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName)), nameOnCard = _React$useState3[0], setNameOnCard = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(''), postalCode = _React$useState4[0], setPostalCode = _React$useState4[1];
    var _React$useState5 = react_1.default.useState(''), phone = _React$useState5[0], setPhone = _React$useState5[1];
    var cardNumber = stripeElements === null || stripeElements === void 0 ? void 0 : stripeElements.getElement(react_stripe_js_1.CardNumberElement);
    var _React$useState6 = react_1.default.useState(false), cardNumberValid = _React$useState6[0], setCardNumberValid = _React$useState6[1];
    var _React$useState7 = react_1.default.useState(false), cardExpiresValid = _React$useState7[0], setCardExpiresValid = _React$useState7[1];
    var _React$useState8 = react_1.default.useState(false), cardCvcValid = _React$useState8[0], setCardCvcValid = _React$useState8[1];
    var _React$useState9 = react_1.default.useState(false), formValid = _React$useState9[0], setFormValid = _React$useState9[1];
    react_1.default.useEffect(function () {
        setFormValid(!!cardNumberValid && !!cardExpiresValid && !!cardCvcValid && !!postalCode && !!nameOnCard);
    }, [cardNumberValid, cardExpiresValid, cardCvcValid, postalCode, nameOnCard]);
    react_1.default.useEffect(function () {
        console.log(bespokeCallTime);
        console.log(bespokeCallDate);
    });
    var times = ['9am EST', '10am EST', '11am EST', '12pm EST', '1pm EST', '2pm EST', '3pm EST', '4pm EST', '5pm EST'];
    var dates = [];
    var gsDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var today = new Date();
    for (var i = 1; i <= 7; i++) {
        var nextDate = new Date();
        nextDate.setDate(today.getDate() + i);
        if (nextDate.getDay() > 0 && nextDate.getDay() < 6) {
            // Monday through Friday
            dates.push(gsDayNames[nextDate.getDay()]);
        }
    }
    var _React$useState10 = react_1.default.useState(dates[0]), bespokeCallDate = _React$useState10[0], setBespokeCallDate = _React$useState10[1];
    var _React$useState11 = react_1.default.useState(times[2]), bespokeCallTime = _React$useState11[0], setBespokeCallTime = _React$useState11[1]; // Setup a payment method for future billing, and process.
    // https://stripe.com/docs/payments/save-and-reuse
    var processPayment = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ regenerator_1.default.mark(function _callee2() {
            var _yield$PriorApi$then$, client_secret, _yield$stripe$confirm, error, setupIntent;
            return regenerator_1.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(!stripe || !stripeElements)) {
                                _context2.next = 2;
                                break;
                            }
                            return _context2.abrupt("return");
                        case 2:
                            setProcessing(true); // get a key for the setupIntent
                            _context2.next = 5;
                            return _api_1.default('createStripeSetupIntent').then(function (r) {
                                return r.json();
                            }).catch(function (e) {
                                return console.log('client secret missing', e);
                            });
                        case 5:
                            _yield$PriorApi$then$ = _context2.sent;
                            client_secret = _yield$PriorApi$then$.client_secret;
                            _context2.next = 9;
                            return stripe.confirmCardSetup(client_secret, {
                                payment_method: {
                                    card: cardNumber,
                                    /* "Hey where's the expiration date and CVC?"
                                     * Stripe uses 'magic' (it's watching in the iFrames).
                                     */
                                    billing_details: {
                                        name: nameOnCard,
                                        email: user === null || user === void 0 ? void 0 : user.email,
                                        address: {
                                            postal_code: postalCode
                                        }
                                    }
                                }
                            });
                        case 9:
                            _yield$stripe$confirm = _context2.sent;
                            error = _yield$stripe$confirm.error;
                            setupIntent = _yield$stripe$confirm.setupIntent;
                            if (!(error || !setupIntent || !setupIntent.payment_method || setupIntent.status !== 'succeeded')) {
                                _context2.next = 16;
                                break;
                            }
                            setNotification({
                                type: 'warning',
                                title: 'Payment information error',
                                message: error === null || error === void 0 ? void 0 : error.message
                            });
                            setProcessing(false);
                            throw new Error(error === null || error === void 0 ? void 0 : error.message);
                        case 16:
                            _context2.next = 18;
                            return _api_1.default('createSubscription', {
                                paymentMethodId: setupIntent.payment_method,
                                recurring: recurring,
                                bespokeCallDate: bespokeCallDate,
                                bespokeCallTime: bespokeCallTime,
                                tier: tier,
                                phone: phone
                            }).then(/*#__PURE__*/ function () {
                                var _ref3 = _asyncToGenerator(/*#__PURE__*/ regenerator_1.default.mark(function _callee(response) {
                                    return regenerator_1.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    if (!(response.status !== 204)) {
                                                        _context.next = 2;
                                                        break;
                                                    }
                                                    throw new Error(response.statusText);
                                                case 2:
                                                    setNotification({
                                                        type: 'confirmation',
                                                        title: tier === 'community' ? 'Payment successful' : 'Account created',
                                                        message: tier === 'community' ? "We successfully processed your payment. A receipt has been sent to \u2018" + (user === null || user === void 0 ? void 0 : user.email) + "\u2019." : "We successfully created your PRIOR account. A welcome email has been sent to \u2018" + (user === null || user === void 0 ? void 0 : user.email) + "\u2019."
                                                    }); // Cleanup
                                                    setTier(''); // TODO: clean localstorage
                                                    _context.next = 6;
                                                    return _api_1.default('syncStripePaymentMethods');
                                                case 6:
                                                    _api_1.default('authenticate').then(function (r) {
                                                        return r.json().then(function (user) {
                                                            setProcessing(false);
                                                            setUser(user);
                                                            setPanel('welcome');
                                                        });
                                                    });
                                                case 7:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee);
                                }));
                                return function (_x) {
                                    return _ref3.apply(this, arguments);
                                };
                            }()).catch(function (e) {
                                setNotification({
                                    type: 'warning',
                                    title: 'Error',
                                    message: e.message
                                });
                                setProcessing(false);
                                throw new Error(e);
                            });
                        case 18:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2);
        }));
        return function processPayment() {
            return _ref2.apply(this, arguments);
        };
    }();
    var setDigital = function setDigital() {
        // If user registered with a paid tier, and then changes their mind on Checkout…
        _api_1.default('updateUser', Object.assign({}, user, {
            'tier': 'digital'
        })).then(function () {
            return setPanel('welcome');
        });
    };
    if (!stripe || !stripeElements) {
        return /*#__PURE__*/ react_1.default.createElement(atoms_1.Spinner, {
            color: _theme_1.palette.ink
        });
    }
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        name: "tier",
        value: tier,
        label: "Membership Type",
        onChange: function onChange(e) {
            return setTier(e.target.value);
        },
        options: ['digital', 'community', 'bespoke'],
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "tel",
        value: phone,
        label: "Phone Number",
        name: "phone",
        onChange: setPhone,
        required: true,
        disabled: processing
    })), tier !== 'digital' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: nameOnCard,
        label: "Name on card",
        name: "nameOnCard",
        onChange: function onChange(e) {
            return setNameOnCard(e.target.value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        required: true,
        label: "Credit Card Number",
        onChange: function onChange(e) {
            return setCardNumberValid(!e.empty && e.complete);
        },
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardNumberElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    }))), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        label: "Expiration Date",
        onChange: function onChange(e) {
            return setCardExpiresValid(!e.empty && e.complete);
        },
        required: true,
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardExpiryElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        label: "Security Code",
        onChange: function onChange(e) {
            return setCardCvcValid(!e.empty && e.complete);
        },
        required: true,
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardCvcElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    }))), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: postalCode,
        label: "Postal Code",
        name: "postalCode",
        onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return setPostalCode(value);
        },
        required: true,
        disabled: processing
    })), tier === 'bespoke' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.CaptionSmall, {
        paddingFull: true
    }, "We\u2019d love to chat before processing your application and payment, please select your prefered time and date for a call."), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        value: bespokeCallDate,
        label: "Preferred Day",
        name: "bespokeCallDate",
        onChange: function onChange(e) {
            return setBespokeCallDate(e.target.value);
        },
        options: dates,
        required: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        value: bespokeCallTime,
        label: "Preferred Time",
        name: "bespokeCallTime",
        onChange: function onChange(e) {
            return setBespokeCallTime(e.target.value);
        },
        options: times,
        required: true,
        disabled: processing
    }))), AccountInHeader_1.tiers.filter(function (t) {
        return t.name === tier;
    }).map(function (t) {
        return /*#__PURE__*/ react_1.default.createElement(exports.CheckoutRowWrapper, {
            key: t.name
        }, /*#__PURE__*/ react_1.default.createElement(exports.CheckoutRow, null, /*#__PURE__*/ react_1.default.createElement("dt", null, "subtotal"), /*#__PURE__*/ react_1.default.createElement("dd", null, "$", _utils_1.money(t.priceInCents))), /*#__PURE__*/ react_1.default.createElement(exports.CheckoutRow, {
            large: true
        }, /*#__PURE__*/ react_1.default.createElement("dt", null, "total"), /*#__PURE__*/ react_1.default.createElement("dd", null, "$", _utils_1.money(t.priceInCents), tier === 'bespoke' && '*')), tier === 'bespoke' && /*#__PURE__*/ react_1.default.createElement(exports.CheckoutRow, null, /*#__PURE__*/ react_1.default.createElement("p", null, "*You will not be charged until your application has been approved.")));
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.InputCheckbox, {
        name: "recurring",
        onChange: toggleRecurring,
        checked: recurring,
        outline: true
    }, "I\u2019d like PRIOR to charge my card annually. You will always receive a notification before being charged."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        shadow: true,
        size: "large",
        display: "flex",
        disabled: processing || !formValid,
        onClick: function onClick() {
            return processPayment();
        }
    }, {
        processing: processing
    }), tier === 'community' && /*#__PURE__*/ react_1.default.createElement("span", null, "Purchase Membership"), tier === 'bespoke' && /*#__PURE__*/ react_1.default.createElement("span", null, "Schedule Call")))), tier === 'digital' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement("dl", null, /*#__PURE__*/ react_1.default.createElement(exports.CheckoutRow, {
        large: true
    }, /*#__PURE__*/ react_1.default.createElement("dt", null, "total"), /*#__PURE__*/ react_1.default.createElement("dd", null, "Free"))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        shadow: true,
        size: "large",
        display: "flex",
        onClick: function onClick() {
            return setDigital();
        }
    }, "Continue"))));
}; // Supporting Component
var PaymentFormWrapper = function PaymentFormWrapper(props) {
    return /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.Elements, {
        stripe: stripePromise,
        options: {
            fonts: [{
                    cssSrc: 'https://fonts.googleapis.com/css?family=Inter:semibold'
                }]
        }
    }, /*#__PURE__*/ react_1.default.createElement(PaymentForm, props));
}; // Typing
// Styling
exports.CheckoutRowWrapper = styled_components_1.default.div.withConfig({
    displayName: "PaymentForm__CheckoutRowWrapper",
    componentId: "sc-1sk252e-0"
})(["padding:16px 0;", "{padding:24px 0;}"], _utils_1.mediaQuery('laptop'));
exports.CheckoutRow = styled_components_1.default.div.withConfig({
    displayName: "PaymentForm__CheckoutRow",
    componentId: "sc-1sk252e-1"
})(["display:flex;justify-content:space-between;padding:", "px 0;", " color:", ";& > p{width:100%;padding-top:4px;", " text-align:right;text-transform:none !important;color:", ";}"], function (props) {
    return props.large ? '12' : '8';
}, function (props) {
    return props.large ? _theme_1.type.labelLarge : _theme_1.type.label;
}, function (props) {
    return props.large ? _theme_1.palette.ink : _theme_1.palette.rifle;
}, _theme_1.type.pSmallSans, _theme_1.palette.vermillion);
exports.default = PaymentFormWrapper;
